import React, { useState } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import ContactUsModal from "../ContactUsModal/ContactUsModal";
import "./AuthPage.css";

const AuthPage = () => {
  const [mode, setMode] = useState("login");
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <GoogleOAuthProvider clientId="694655215480-voa8p9mardcmets01d91rgbeuna584d6.apps.googleusercontent.com">
    <div className="auth-container">
      <div className="auth-layout">
        <div className="auth-box">
          <h1 className="auth-title">🎬 ویدیو پلیر</h1>
          <p className="auth-subtitle">
            {mode === "login" && "برای استفاده از ویدئوپلیر وارد شوید"}
            {mode === "register" && "عضو شوید و از یادگیری زبان با فیلم لذت ببرید"}
            {mode === "forgot" && "رمز عبور جدید تنظیم کنید"}
          </p>

          {mode === "login" && (
            <LoginForm
              onSwitchToRegister={() => setMode("register")}
              onSwitchToForgot={() => setMode("forgot")}
            />
          )}

          {mode === "register" && (
            <RegisterForm onSwitchToLogin={() => setMode("login")} />
          )}

          {mode === "forgot" && (
            <ForgotPasswordForm onSwitchToLogin={() => setMode("login")} />
          )}

        </div>

        <div className="auth-hero">
          <div className="auth-video-card" onClick={() => setIsVideoOpen(true)}>
            <img
              src="/img/landing.webp"
              alt="معرفی اوملنگ"
              className="auth-video-thumb"
            />
            <div className="auth-video-play">
              <svg width="56" height="56" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="11" fill="rgba(0,0,0,0.5)" stroke="rgba(255,255,255,0.8)" strokeWidth="1.5"/>
                <path d="M10 8.5v7l5.5-3.5z" fill="white"/>
              </svg>
            </div>
          </div>
          <p className="auth-hero-title">آشنایی با اوملنگ</p>
          <p className="auth-hero-desc">
            یادگیری زبان با فیلم و سریال، روشی نوین و لذت‌بخش
          </p>

          <a
            href="https://app.umlang.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="auth-mobile-btn"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
              <line x1="12" y1="18" x2="12.01" y2="18"/>
            </svg>
            اپلیکیشن موبایل
          </a>

          <button
            type="button"
            onClick={() => setIsContactModalOpen(true)}
            className="auth-link"
          >
            پشتیبانی
          </button>
        </div>
      </div>

      {isVideoOpen && (
        <div className="video-modal-overlay">
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal-close" onClick={() => setIsVideoOpen(false)}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
            <video
              className="video-modal-player"
              src="/videos/landing.mp4"
              controls
              autoPlay
              playsInline
            />
          </div>
        </div>
      )}

      <ContactUsModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </div>
    </GoogleOAuthProvider>
  );
};

export default AuthPage;
